/** MIME types accepted by POST /api/tenant/upload/files for images and fingerprint images. */
export const TRACKED_UPLOAD_ALLOWED_IMAGE_MIMES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/x-ms-bmp',
  'image/tiff',
] as const;

export type TrackedUploadAllowedImageMime = (typeof TRACKED_UPLOAD_ALLOWED_IMAGE_MIMES)[number];

/** File-picker accept string aligned with TRACKED_UPLOAD_ALLOWED_IMAGE_MIMES. */
export const TRACKED_UPLOAD_IMAGE_ACCEPT =
  '.png,.jpg,.jpeg,.gif,.webp,.bmp,.tif,.tiff,image/png,image/jpeg,image/gif,image/webp,image/bmp,image/x-ms-bmp,image/tiff';

const imageExtensionToMime: Record<string, TrackedUploadAllowedImageMime> = {
  '.png': 'image/png',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.gif': 'image/gif',
  '.webp': 'image/webp',
  '.bmp': 'image/bmp',
  '.tif': 'image/tiff',
  '.tiff': 'image/tiff',
};

const trackedUploadImageMimeAliases: Record<string, TrackedUploadAllowedImageMime> = {
  'image/x-ms-bmp': 'image/bmp',
};

export function isTrackedUploadAllowedImageFile(file: { type: string; name: string }): boolean {
  const normalizedType = trackedUploadImageMimeAliases[file.type] ?? file.type;
  if (TRACKED_UPLOAD_ALLOWED_IMAGE_MIMES.includes(normalizedType as TrackedUploadAllowedImageMime)) {
    return true;
  }
  const lower = file.name.toLowerCase();
  for (const [ext, mime] of Object.entries(imageExtensionToMime)) {
    if (lower.endsWith(ext)) {
      return TRACKED_UPLOAD_ALLOWED_IMAGE_MIMES.includes(mime);
    }
  }
  return false;
}
